import { render, staticRenderFns } from "./OnlineDashboard.vue?vue&type=template&id=5c754905&"
import script from "./OnlineDashboard.vue?vue&type=script&lang=js&"
export * from "./OnlineDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OnlineDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnlineDashboard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VDialog,
  VFlex,
  VLayout,
  VProgressLinear,
})
